var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCompetition = function SvgLogoBrandCompetition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Wettbewerbslogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 70,
    viewBox: "0 0 200 70",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004ba0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#008cc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#28a6db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#49bbea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55c3f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004ba0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#007abd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#008cc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#26a4da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#48bbea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55c3f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e60028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#c50645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#a60b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#930e72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8c0f78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597,
    stopColor: "#881078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#7b1278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#661578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#491978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281e78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55c3f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#49bbea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#28a6db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#008cc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004ba0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#281e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#291e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#531778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#721378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#851078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8c0f78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#930e72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#a60b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#c50645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e60028"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1057",
    "data-name": "Rechteck 1057",
    width: 200,
    height: 70,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NEW_Logo_RGB",
    transform: "translate(9 -3.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2236",
    "data-name": "Gruppe 2236",
    transform: "translate(-9 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11467",
    "data-name": "Pfad 11467",
    d: "M168.57,5.17a3.677,3.677,0,0,0-3.5,2.74l-6.44,26.02s-.68,2.74-1.5.04l-5.59-18.26c-6.96,5.47-14.29,10.86-21.63,15.68l-.79,2.58s-.83,2.7-1.5-.04l-.23-.91s-8.41,5.16-12.53,7.35l3.82,13.86c7.24-2.05,14.04-4.21,20.38-6.4l3.19-9.73s.88-2.68,1.76,0l2.33,7.12c10.38-3.84,19.37-7.71,26.85-11.24L180.33,7.9s.75-2.72-2.08-2.72h-9.68ZM3.3,38.33V62a2.762,2.762,0,0,0,2.82,2.82h9.02A2.734,2.734,0,0,0,17.96,62V44.87Zm22.48,8.79,9.76,15.33a5.51,5.51,0,0,0,4.34,2.38h7.17a2.73,2.73,0,0,0,2.82-2.82V51.02Zm32.81,3.92V62a2.73,2.73,0,0,0,2.82,2.82h8.05c10.45-1.57,20.35-3.47,29.68-5.6V54.58a2.762,2.762,0,0,0-2.82-2.82H76.08a3.187,3.187,0,0,1-2.21-.97c-5.43.28-10.52.35-15.28.25M189.55,5.17a3.261,3.261,0,0,0-3.33,3.33V18.7c0,.67.54,4.12,3.21,1.79,0,0,3.92-3.28,4.43-3.72a8.039,8.039,0,0,0,2.85-5.89V8.9c0-.48,0-3.74-3.33-3.74h-3.83Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11468",
    "data-name": "Pfad 11468",
    d: "M35.22,24.85v7.49s0,2.82-1.52.44l-4.54-7.12A196.5,196.5,0,0,1,3.29,26.92v6.05a207.427,207.427,0,0,0,46.58,4.84V21.34c-4.68,1.13-9.57,2.75-14.65,3.51M92.78,5.17A166.713,166.713,0,0,1,58.59,19.66V37.45a128.449,128.449,0,0,0,36.59-7.46,2.547,2.547,0,0,0-2.63-1.79H76.08a2.762,2.762,0,0,1-2.82-2.82V21.06a2.708,2.708,0,0,1,2.82-2.82H96.32a2.762,2.762,0,0,0,2.82-2.82V8a2.762,2.762,0,0,0-2.82-2.82H92.78Zm15.22,0s-2.82,0-2.07,2.72l4.13,15.01c.86-.51,1.7-1.03,2.54-1.57,3.55-2.28,6.97-4.53,10.25-6.7l-1.66-6.72a3.678,3.678,0,0,0-3.5-2.74H108Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11469",
    "data-name": "Pfad 11469",
    d: "M6.12,5.17A2.762,2.762,0,0,0,3.3,7.99V26.94a196.83,196.83,0,0,0,25.88-1.26L17.63,7.55a5.51,5.51,0,0,0-4.34-2.38Zm31.92,0a2.762,2.762,0,0,0-2.82,2.82V24.87c5.08-.76,9.97-1.72,14.66-2.85V8a2.762,2.762,0,0,0-2.82-2.82H38.04Zm23.38,0A2.762,2.762,0,0,0,58.6,7.99v11.7A166.609,166.609,0,0,0,92.91,5.17Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11470",
    "data-name": "Pfad 11470",
    d: "M3.3,38.33a66.149,66.149,0,0,0,14.66,6.69V37.66s0-2.82,1.52-.44l6.44,10.11a141.31,141.31,0,0,0,23.97,3.69V36.61A195.925,195.925,0,0,1,3.31,30.54H3.3v7.79Zm55.29-1.81V51.44c.23.01.47.01.7.01.26,0,.51.01.77.01h1.69c.3,0,.6,0,.9-.01s.62-.01.93-.01.63-.01.94-.01.63-.01.95-.01.63-.01.95-.02.63-.01.94-.02.61-.01.92-.02.59-.01.89-.02c.28-.01.57-.01.85-.02s.53-.01.8-.02c.25-.01.49-.01.74-.02.22-.01.45-.01.67-.02.2-.01.4-.01.6-.02.17,0,.34-.01.51-.02.14,0,.28-.01.41-.01.1,0,.21-.01.31-.01a1.21,1.21,0,0,0,.19-.01h.07a.035.035,0,0,0-.02-.01c-.03-.03-.11-.08-.15-.12a2.558,2.558,0,0,1-.46-.52,2.711,2.711,0,0,1-.36-.86,3.19,3.19,0,0,1-.08-.75V44.1a2.762,2.762,0,0,1,2.82-2.82H92.54a2.762,2.762,0,0,0,2.82-2.82V31.04a3.49,3.49,0,0,0-.24-1.15,121.787,121.787,0,0,1-36.53,6.63M112.6,21.33c-.84.54-1.69,1.06-2.54,1.57l4.93,17.91c4.31-2.05,8.52-4.33,12.66-6.8-.01-.03-.01-.05-.02-.08l-4.78-19.34c-.01,0-6.68,4.45-10.25,6.74M140.76,5.17a3.927,3.927,0,0,0-3.65,2.7l-7.66,25.05a235.7,235.7,0,0,0,22.51-15.88l-2.81-9.17a3.93,3.93,0,0,0-3.65-2.7h-4.74Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11471",
    "data-name": "Pfad 11471",
    d: "M62.36,64.83H96.33a2.762,2.762,0,0,0,2.82-2.82V57.35m19.02-4.97,2.68,9.72a3.792,3.792,0,0,0,3.57,2.72h6.25a4.017,4.017,0,0,0,3.7-2.68l5.46-16.66s-14.11,4.75-21.66,6.9m27.55-9.05,6.17,18.82a4.017,4.017,0,0,0,3.7,2.68h6.34a3.791,3.791,0,0,0,3.57-2.72l8.58-31.32c-.01,0-18.21,8.7-28.36,12.54",
    fill: "url(#linear-gradient-5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCompetition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-competition.2501c4eb32bf3c0d0c3c2b293e3209dc.svg";